import { List, Text } from '@mantine/core';
export type ChatRuleItemProps = {
  text: string;
};
export const ChatRuleItem: React.FC<ChatRuleItemProps> = ({
  text
}) => {
  return <List.Item p="md" fz="sm" c="var(--text-dark)" fw={500}>
      <Text inherit>{text}</Text>
    </List.Item>;
};